
<template>
    <BreadCrumb PageTitle="Créer un BESC - Étape 1/4" />
    <AddBescStep1 />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddBescStep1 from "@/components/BESC/AddBesc/AddBescStep1.vue"
  
    export default defineComponent({
      name: "AddBescStep1Page",
      components: {
        BreadCrumb,
        AddBescStep1,
      },
    });
  </script>